import React from 'react';
import { Search, List, Phone } from 'lucide-react';

export function FreeFeatures() {
  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 mb-12">
      <h2 className="text-2xl font-bold text-gray-900 mb-8">
        Hur fungerar vår gratis funktion?
      </h2>
      <div className="grid md:grid-cols-3 gap-8">
        {[
          { 
            icon: <Search className="w-6 h-6 text-[#A3C1DA]" />,
            number: "1", 
            text: "Ange sökord kopplade till ditt ändamål eller område och upptäck matchande stiftelser." 
          },
          { 
            icon: <List className="w-6 h-6 text-[#A3C1DA]" />,
            number: "2", 
            text: "Se grundläggande information om stiftelser som passar dina behov." 
          },
          { 
            icon: <Phone className="w-6 h-6 text-[#A3C1DA]" />,
            number: "3", 
            text: "Få tillgång till kontaktuppgifter för att ansöka om stöd på egen hand." 
          }
        ].map((step, index) => (
          <div 
            key={index} 
            className="bg-[#F2C1D1]/10 p-6 rounded-xl transform hover:scale-105 transition-transform"
          >
            <div className="flex items-center mb-4">
              <div className="text-[#A3C1DA] text-4xl font-bold mr-3">{step.number}</div>
              {step.icon}
            </div>
            <p className="text-gray-700">{step.text}</p>
          </div>
        ))}
      </div>
      
      <div className="mt-8 p-4 bg-gray-50 rounded-xl border border-gray-100">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">Gratis funktioner inkluderar:</h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-gray-600">
          <li className="flex items-center">
            <span className="h-2 w-2 bg-[#A3C1DA] rounded-full mr-2"></span>
            Grundläggande sökfunktion
          </li>
          <li className="flex items-center">
            <span className="h-2 w-2 bg-[#A3C1DA] rounded-full mr-2"></span>
            Stiftelselistning med basinformation
          </li>
          <li className="flex items-center">
            <span className="h-2 w-2 bg-[#A3C1DA] rounded-full mr-2"></span>
            Kontaktuppgifter för stiftelser
          </li>
          <li className="flex items-center">
            <span className="h-2 w-2 bg-[#A3C1DA] rounded-full mr-2"></span>
            Obegränsad stiftelsesökning
          </li>
          <li className="flex items-center">
            <span className="h-2 w-2 bg-[#A3C1DA] rounded-full mr-2"></span>
            Begränsad användning i verktyget
          </li>
        </ul>
      </div>
    </div>
  );
}
